import { Collapse, ListItem, ListItemText } from '@material-ui/core';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { Link } from 'react-router-dom';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

function NavSection(props) {
  const { item,isOpen,onClick,onClick1 } = props;

  const isExternal = url => {
    return /^https?:\/\//.test(url);
  };

  return (
  <div style={{ fontSize: '14px' }}>
    <ListItem button onClick={onClick}>
      <ListItemIcon>
        <div style={{ color: '#FFF', fontSize: '14px' }}>{item.icon}</div>
      </ListItemIcon>
      <ListItemText disableTypography style={{ fontSize: '14px' }} primary={item.title} />
      {props.isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
    </ListItem>
    {
      item.children.map(child =>
        <Link
          {...(!isExternal(child.url) && { to: child.url })}
          to={child.url}
          style={{ color: '#FFF', fontSize: '14px', textDecoration: 'none' }}
          key={child.title}
          onClick={() => {
            if (isExternal(child.url)) {
              window.open(child.url, '_self');
            }
            onClick1();
          }}
        >
          <Collapse in={isOpen} timeout='auto' unmountOnExit>
            <ListItem button>
              <div style={{ color: '#FFF', margin: '0 16px', fontSize: '14px' }}>{child.icon}</div>
              <ListItemText className='pl-16' disableTypography style={{ fontSize: '14px' }} primary={child.title} />
            </ListItem>
          </Collapse>
        </Link>,
      )
    }
  </div>
  );
}

export default NavSection;

